namespace advisorop.components.common {

    export class AccountsDdlController {
        // bindings
        householdId: number;
        onItemSelected: any;
        onIAmReady: any;

        // other properties
        userSelected: boolean = false;
        hhData = [];
        selItemData: any;
        selItemID: any;
        tvHHInst: DevExpress.ui.dxTreeView;

        tvHH: DevExpress.ui.dxTreeViewOptions = {
            bindingOptions: {
                value: 'vm.selItemID',
                dataSource: 'vm.hhData'
            },
            dataStructure: "plain",
            keyExpr: "ID",
            parentIdExpr: "categoryId",
            displayExpr: "name",
            selectByClick: true,
            selectNodesRecursive: false,
            selectionMode: "single",
            // height: "150",
            onContentReady: (e) => {
                this.tvHHInst = e.component;
                this.tvHHInst.unselectAll();
                this.tvHHInst.selectItem(this.selItemID);
            },
            onItemSelectionChanged: (args: any) => {
                this.selItemData = args.itemData;
                // console.log(`AccountsDdl tvHH: onItemSelectionChanged`)
                this.setSelItemId(args.itemData.ID, true);
            },
        }

        cbHH: DevExpress.ui.dxDropDownBoxOptions = {
            bindingOptions: {
                value: 'vm.selItemID',
                dataSource: 'vm.hhData'
            },
            valueExpr: "ID",
            displayExpr: "name",
            placeholder: "Select a item...",
            showClearButton: false,
            onValueChanged: (e) => {
                if (this.selItemData) {
                    // emmit event so parent control can take some action
                    if (this.userSelected) {
                        // console.log(`AccountsDdl: Firing event onItemSelected userSelected: ${this.userSelected}`);
                        this.onItemSelected({ itemData: this.selItemData });
                    }
                }

                // sync treeview with drop down
                if (this.tvHHInst) {
                    this.tvHHInst.unselectAll();
                    this.tvHHInst.selectItem(this.selItemID);
                }
                e.component.close();
            }
        }

        //static $inject = ["advisorService", "generalService"];
        constructor(
            //private advisorService: advisorop.services.AdvisorService,
            //private generalService: advisorop.services.GeneralService
        ) { }

        //
        setSelItemId = (value, userSelected: boolean = false) => {
            if (this.selItemID != value) {
                this.userSelected = userSelected;
                this.selItemID = value;
                // console.log(`----> selItemID:${this.selItemID}, userSelected: ${this.userSelected}`);
            }
        }

        // helper methods
        formatZeroDpCurrency(num: number): string {
            var ret = '$' + num.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
            return ret;
        }

        prepareDropDownData(accounts: any[], hideSleeves: boolean = false) {
            this.hhData = [];

            if (this.householdId) {
                const hhEl = {
                    "ID": this.householdId,
                    "categoryId": null,
                    "name": "Household level",
                    "caption": "Household level",
                    "level": "H",
                    "expanded": true,
                    "item": null
                };
                if (accounts.length > 0) {
                    hhEl.name = accounts[0].householdName;
                    hhEl.caption = accounts[0].householdName + " - Household Level";
                    hhEl.item = accounts[0];
                }
                this.hhData.push(hhEl);
            }

            let groupLvl = null;
            let accountLvl = null;

            for (var i = 0; i < accounts.length; i++) {
                let a = accounts[i];
                // group level
                if (this.householdId != null) {
                    if (groupLvl == null || this.hhData.every(s => s.ID != `${this.householdId}_${a.groupId}`)) {
                        groupLvl = {
                            "ID": `${this.householdId}_${a.groupId}`,
                            "categoryId": this.householdId, //in case of RTG this will be a null
                            "name": `${a.groupDescription}`,
                            "caption": `${a.groupDescription} - Account Group`,
                            "level": "R",
                            "expanded": true,
                            "item": a
                        };
                        this.hhData.push(groupLvl);
                    }
                } else {
                    if (groupLvl == null || this.hhData.every(s => s.ID != `${a.groupId}`)) {
                        groupLvl = {
                            "ID": `${a.groupId}`,
                            "categoryId": this.householdId, //in case of RTG this will be a null
                            "name": `${a.groupDescription}`,
                            "caption": `${a.groupDescription} - Account Group`,
                            "level": "R",
                            "expanded": true,
                            "item": a
                        };
                        this.hhData.push(groupLvl);
                    }
                }
                // account level
                if (accountLvl == null || this.hhData.every(s => s.ID != `${a.groupId}_${a.accountId}`)) {
                    var acctValue = 0.0;
                    acctValue = accounts.filter(item => item.accountId === a.accountId && item.groupId === a.groupId)
                        .reduce((acctValue, current) => acctValue + current.usdMarketValue, 0);
                    accountLvl = {
                        "ID": `${a.groupId}_${a.accountId}`,
                        "categoryId": groupLvl.ID, //`${a.groupId}_${a.accountId}`,
                        "name": `${a.level3Caption} (${a.accountNumber} ${this.formatZeroDpCurrency(acctValue)}) `,
                        "caption": `${a.level3Caption} (${a.accountNumber} ${this.formatZeroDpCurrency(acctValue)}) `,
                        "level": "A",
                        "expanded": false,
                        "item": a
                    };
                    this.hhData.push(accountLvl);
                }
                // sleeve level
                if (!hideSleeves && a.boModelId && (a.boModelId > 0 || a.boModelId == -1) && this.hhData.every(s => s.ID != `${a.groupId}_${a.accountId}_${a.boModelId}`)) {   // special case where model Id == -1 is the cash sleeve
                    var slvValue = 0.0;
                    slvValue = accounts.filter(item => item.accountId === a.accountId && item.groupId === a.groupId && item.boModelId === a.boModelId)
                        .reduce((slvValue, current) => slvValue + current.usdMarketValue, 0);
                    const sleeveEl = {
                        "ID": `${a.groupId}_${a.accountId}_${a.boModelId}`,
                        "categoryId": accountLvl.ID,
                        "name": `${a.level3Caption} (${a.accountNumber}) - ${a.modelDescription} (${this.formatZeroDpCurrency(slvValue)})`,
                        "caption": `${a.level3Caption} (${a.accountNumber}) - ${a.modelDescription} (${this.formatZeroDpCurrency(slvValue)})`,
                        "level": "S",
                        "expanded": false,
                        "item": a
                    };
                    this.hhData.push(sleeveEl);
                }
            }
            //console.log("HH DATA DROPDOWN RESULT", this.hhData);
        }


        // overrides
        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }
            for (var key in evt) {
                if (key === "householdId") {
                    this.setSelItemId(this.householdId);
                }
            }
        }

        $onInit() {
            this.onIAmReady({ ctrl: this });
        }
    }

    class AccountsDdl implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "householdId": "<",
                "onItemSelected": "&",
                "onIAmReady": "&"
            };
            this.controller = AccountsDdlController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/accounts-ddl.html";
        }

    }
    angular.module(Constants.APP).component("accountsDdl", new AccountsDdl());
}